<template>
  <a-modal
    :maskStyle="{ backgroundColor: 'rgba(10, 15, 26, 0.1)' }"
    v-model="visible"
    :footer="null"
    :closable="false"
    class="app-about"
    centered
    :keyboard="false"
    :maskClosable="false"
  >
    <div class="about-box">
      <div class="content">
        <span>{{ $t("login.AgreementDescription1") }}</span>
        <a
          href="./protocol/service"
          target="_blank"
          style="color: #236CFF;font-weight: 500; margin-right: 5px;"
          >{{ $t("login.UserServiceAgreement") }}</a
        >
        <span>{{ $t("login.and") }}</span>
        <a
          href="./protocol/privacy"
          target="_blank"
          style="color: #236CFF;font-weight: 500; margin-left: 5px;"
          >{{ $t("login.PrivacyPolicy") }}</a
        >
        <span>{{ $t("login.AgreementDescription2") }}</span>
      </div>
      <BasicBtnGroup
        class="invite-btn-group"
        @primeClick="agreeUpdateHandle"
        @defClick="disagreeUpdateHandle"
      >
        <template slot="defContent">{{ $t("login.Disagree") }}</template>
        <template slot="primaryContent">{{
          $t("login.AgreeContinue")
        }}</template>
      </BasicBtnGroup>
    </div>
  </a-modal>
</template>

<script>
import { getAgreementStatus, setAgreementUpdate } from '@/api/common'
import BasicBtnGroup from '../../behavior/basic-btn-group/index.vue'
import { mapActions } from 'vuex'
import { Modal } from 'ant-design-vue'

export default {
  name: 'Agreement',
  components: {
    BasicBtnGroup
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    ...mapActions(['doLogout']),
    async getAgreementStatusHandle() {
      const ret = await getAgreementStatus()
      if (!ret.latestVersionAgree) {
        this.visible = true
      }
    },
    async agreeUpdateHandle() {
      await setAgreementUpdate()
      this.visible = false
    },
    async disagreeUpdateHandle() {
      Modal.destroyAll()
      this.doLogout()
    }
  }
}
</script>

<style scoped lang="less">
.app-about {
  ::v-deep .ant-modal {
    max-width: 460px;
    padding: 0;
    margin-bottom: 50px;

    .ant-modal-content {
      box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
      border-radius: 16px;
      border: 1px solid #edeff2;
    }
  }
  .about-box {
    .content {
      font-size: 18px;
      font-weight: 500;
      color: #000;
    }

    .invite-btn-group {
      margin-top: 40px;
      justify-content: flex-end;

      ::v-deep .default-btn{
        padding: 10px 32px;
        margin-right: 27px;
        color: #000;
      }
      ::v-deep  .primary-btn {
        padding: 10px 16px;
        margin-right: 27px;
      }
    }
  }
}
</style>
